import React from 'react'
import { ICommentObject } from 'types'
import { dateTime, getDifferenceInSeconds } from 'helpers/date'
import { validateSourceUrl } from 'helpers/utils'
interface ICommentUserProps {
  comment: ICommentObject
}

const CommentUser: React.FC<ICommentUserProps> = ({ comment }) => {
  if (!comment || !comment.user) {
    return null
  }

  const fixedCreatedAt = dateTime(new Date(comment.createdAt))
  const fixedUpdatedAt = dateTime(new Date(comment.updatedAt))
  const editTime = getDifferenceInSeconds(fixedUpdatedAt, fixedCreatedAt)
  const isEdited = comment.updatedAt && editTime > 0
  const createdDateFormatted = fixedCreatedAt.toLocaleDateString()

  return (
    <div className="flex items-center gap-2 text-sm m-[5px] min-w-0">
      <img
        src={validateSourceUrl(comment.user?.profilePicture)}
        className="object-cover rounded-full w-7 h-7 flex-shrink-0"
        alt={comment.user?.name || 'Anonymous user'}
      />
      <div className="flex flex-col leading-tight min-w-0">
        <span className="font-bold text-body truncate">{comment.user!.name}</span>
        <span className="text-xs text-muted">
          {createdDateFormatted}
          {isEdited && <span className="ml-1">(edited)</span>}
        </span>
      </div>
    </div>
  )
}
export default CommentUser
